// extracted by mini-css-extract-plugin
export var button = "Contact-module--button--gBKw2";
export var buttonWrap = "Contact-module--buttonWrap--lfrSa";
export var container = "Contact-module--container--dgKEf";
export var titlesContainer = "Contact-module--titlesContainer--2hD9O";